'use strict';

var React = require('react');

var SvgLogoCriteoIcon = function SvgLogoCriteoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.853 6.532c-.83-.944-1.995-1.532-3.296-1.532-2.52 0-4.557 1.944-4.557 4.582s2.04 4.56 4.56 4.56c1.302 0 2.467-.592 3.297-1.531.003 0 .004-.002.005-.004l.004-.005c.082-.11.07-.272-.033-.364l-1.182-1.053c-.095-.084-.235-.075-.326.017-.475.492-1.107.768-1.768.773-1.26 0-2.28-1.006-2.28-2.397 0-1.391 1.02-2.41 2.28-2.41.66.005 1.297.281 1.768.773.09.092.231.096.326.013l1.182-1.05.008-.008c.099-.096.103-.259.012-.364Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.459 11.075 1.479 2.335c.04.066.066.14.062.224 0 .215-.166.386-.368.386h-2.264c-.107 0-.215-.048-.293-.132l-.868-1.154c-.343-.43-.789-.294-.789.255v.772c0 .145-.107.259-.244.259h-2.065c-.136 0-.244-.114-.244-.259v-1.606c0-.066.054-.123.116-.128 1.194-.07 2.173-1.15 2.173-2.418 0-1.26-.971-2.362-2.173-2.432-.066-.004-.116-.057-.116-.127v-1.655c0-.145.108-.259.244-.259h3.557c1.656 0 2.999 1.348 2.999 3.055 0 .996-.426 1.861-1.103 2.344h-.004c-.17.118-.21.36-.1.54Z"
  }));
};
SvgLogoCriteoIcon.displayName = "LogoCriteoIcon";

exports.SvgLogoCriteoIcon = SvgLogoCriteoIcon;
